



















import { Component, Prop,Vue } from "vue-property-decorator";

@Component({})
export default class ListItem extends Vue {
    @Prop({ default: 'article', type: String })
    elementName!: string;

    @Prop({ default: false, type: Boolean })
    selectable!: boolean;
}
